import { MouseEvent, ReactNode } from 'react';
import { showMessageBox } from '../modals';
import Button, { ButtonProps } from './Button';

export function ActionButton({
  size = 'small',
  type = 'secondary',
  variant = 'text',
  ...props
}: ButtonProps) {
  return <Button size={size} type={type} variant={variant} {...props} />;
}

export function CancelButton({
  children = 'Cancel',
  icon = 'times',
  ...props
}: ButtonProps) {
  return (
    <ActionButton icon={icon} {...props}>
      {children}
    </ActionButton>
  );
}

export function DeleteButton({
  children = 'Delete',
  confirm = 'Are you sure you want to delete the item?',
  confirmTitle = 'Deleting',
  icon = 'trash',
  onClick,
  ...props
}: {
  confirm?: ReactNode;
  confirmTitle?: string;
} & ButtonProps) {
  async function onButtonClick(e: MouseEvent<HTMLButtonElement>) {
    const buttonId = await showMessageBox({
      content: confirm,
      title: confirmTitle,
      buttons: [
        { icon: 'trash', id: 'delete', title: 'Delete' },
        { id: 'cancel', title: 'Cancel' },
      ],
    });

    if (buttonId === 'delete') {
      return onClick?.(e);
    }

    return undefined;
  }

  return (
    <ActionButton icon={icon} onClick={onButtonClick} {...props}>
      {children}
    </ActionButton>
  );
}

export function EditButton({
  children = 'Edit',
  icon = 'pen',
  type = 'primaryText',
  ...props
}: ButtonProps) {
  return (
    <ActionButton icon={icon} type={type} {...props}>
      {children}
    </ActionButton>
  );
}

export function SaveButton({
  children = 'Save',
  icon = 'save',
  type = 'primaryText',
  ...props
}: ButtonProps) {
  return (
    <ActionButton icon={icon} type={type} {...props}>
      {children}
    </ActionButton>
  );
}
